import React from 'react';
import { Typography, Box } from '@mui/material';
import { Footer } from '../Footer';
import HeroContainer from '../ui/hero-container';
import OrangeButton from '../buttons/orange-button';
import ContactTestimonialCarousel from '../contact/ContactTestimonialCarousel';
import HeaderAlt from '../HeaderAlt';

const Partnerships = () => {
  const publicUrl = process.env.PUBLIC_URL;
  const partner = [
    {
      name: 'Flexible Tutoring Opportunities',
      logo: publicUrl + '/images/partnership/doran-logo.webp',
      description:
        'Expand your tutoring business or kickstart a new one—whether you’re looking for a full-time career or a flexible way to earn extra income.',
      url: 'https://www.doranandscalora.com/',
    },
    {
      name: 'Start Tutoring with Ease',
      logo: publicUrl + '/images/partnership/doran-logo.webp',
      description:
        'New to tutoring? No problem! Access our comprehensive learning resources and connect with our supportive tutor community to get started with confidence.',
      url: 'https://www.doranandscalora.com/',
    },
    {
      name: 'AI Tools for Better Sessions',
      logo: publicUrl + '/images/partnership/doran-logo.webp',
      description:
        'Leverage our unique AI tools to generate customized lesson plans, practice problems, and more—ensuring you’re fully prepared for a productive session, every time.',
      url: 'https://www.doranandscalora.com/',
    },
    {
      name: 'Organize with Smart Dashboard',
      logo: publicUrl + '/images/partnership/doran-logo.webp',
      description:
        'Leverage our unique AI tools to generate customized lesson plans, practice problems, and more—ensuring you’re fully prepared for a productive session, every time.',
      url: 'https://www.doranandscalora.com/',
    },
  ];

  const stages = [
    'Schools & Universities',
    'Independent and Counseling companies',
    'Agencies',
    'Angel Investors',
    'VCs',
    'Crowdfunding platforms',
  ];

  return (
    <div className="flex-container">
      <HeaderAlt />
      <HeroContainer className="landing-section !py-8">
        <p className="tagline fredoka ">🤝 Partner with us</p>
        <h1 className="hero-title fredokaOne !max-w-[922px] !font-normal">
          Together, let’s make education affordable, accessible and efficient
        </h1>
        <p className="description !max-w-[720px]">
          We partner with schools, universities, independent counselors, counseling agencies,
          investors, VCs, incubators, accelerators and more...
        </p>
        <div className="button-container">
          <OrangeButton
            label="Become a partner"
            onClick={() => {
              const targetElement = document.getElementById('becomePartner');
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
          />
        </div>
      </HeroContainer>

      <h2 className="fredokaOne mb-6 mt-8  text-center text-[32px] leading-[1.5] tracking-[-0.64px] text-[#012E33] md:mb-10 md:mt-16 md:text-[40px] md:tracking-[-0.8px]">
        Why partner with IAMAI
      </h2>
      <div className="container grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-4">
        {partner.map((partner, index) => (
          <div className="flex justify-center" key={index}>
            <div
              className="max-w-sm rounded-3xl shadow"
              style={{
                background: 'linear-gradient(136deg, #FFF 8.91%, #F7F7F7 50%)',
                display: 'flex',
                flexDirection: 'column', // Ensure the content stacks vertically
                justifyContent: 'space-between', // Make sure content is spaced out evenly
              }}
            >
              <a href={partner.url} target="_blank" rel="noopener noreferrer">
                <img src={partner.logo} alt={partner.name} className="mx-auto mt-4 h-36 w-auto" />
              </a>
              <div className="flex flex-grow flex-col justify-between p-4">
                {' '}
                {/* Flexbox for content */}
                <h5 className="font-[Fredoka] text-[22px] font-medium leading-normal tracking-[-0.64px] text-[#012E33]">
                  {partner.name}
                </h5>
                <p className="font-[Fredoka] text-[16px] font-normal leading-[26px] tracking-[-0.36px] text-[#678285]">
                  {partner.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="my-[49px] flex w-full flex-col-reverse items-center gap-3 bg-[#F8F8F8] px-6 pt-10 md:mb-[72px] md:mt-[72px] md:flex-row md:justify-around md:pt-16 ">
        <img
          src="/images/partnership/parternship_boy.png"
          alt="partnership_boy"
          className="w-[300px] md:w-[370px] lg:w-[446px]"
        />
        <div className="flex max-w-xl flex-col items-center gap-6 ">
          <h1 className="initiative-title !text-[32px] md:!text-start md:!text-[44px]  ">
            We work with organizations from various sectors and stages of growth
          </h1>
          <div className="space-y-2.5">
            {stages.map((stage, index) => (
              <div className="flex gap-6" key={index}>
                <img src="/images/icons/parternshipCheck.svg" alt="partnershipCHeck" />

                <h1 className="mt-[10px] font-medium text-[#012E33] md:text-xl">{stage}</h1>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="-mt-4 lg:!-mt-28">
        <ContactTestimonialCarousel />
      </div>

      <div id="becomePartner">
        <Box className="mt-7 bg-[#E0F5F5] px-6 py-12 md:py-14" sx={{ textAlign: 'center' }}>
          <Typography
            className="fredokaOne !mx-auto max-w-[606px] !text-center text-[32px] font-normal leading-normal  tracking-[-0.64px] text-[#012E33] md:text-[40px] md:tracking-[-0.8px] "
            variant="h4"
            gutterBottom
          >
            Become a partner
          </Typography>
          <p className="description !mx-auto !max-w-[398px]  !text-center !text-lg md:!px-0 lg:!text-[22px]">
            Interested in becoming a partner? Send us a message using the form below.
          </p>

          <div className="mx-auto mt-6 max-w-[623px] md:mt-9">
            <div className=" space-y-8 rounded-[24px] ">
              <form className="space-y-8">
                <div className="space-y-2">
                  <label className="ml-1 flex text-left font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33] ">
                    First Name*
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your First Name"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white p-4 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2 md:px-5 md:py-[18px]"
                  />
                </div>

                <div className="space-y-2">
                  <label className="ml-1 flex text-left font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                    Last Name*
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your Last Name"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white p-4 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2 md:px-5 md:py-[18px]"
                  />
                </div>

                <div className="space-y-2">
                  <label className="ml-1 flex text-left font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                    Email*
                  </label>
                  <input
                    type="email"
                    placeholder="Enter your Email"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white p-4 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2 md:px-5 md:py-[18px]"
                  />
                </div>

                <div className="space-y-2">
                  <label className="ml-1 flex text-left font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                    Company/Organization Name*
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your Company/Organization Name"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white p-4 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2 md:px-5 md:py-[18px]"
                  />
                </div>

                <div className="space-y-2">
                  <label className="ml- ml-1 flex text-left font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                    How would you like to partner?
                  </label>
                  <textarea
                    rows="4"
                    placeholder="Write a message"
                    className="w-full rounded-[16px] border border-[#DCDCDC] bg-white p-4 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2 md:px-5 md:py-[18px]"
                  ></textarea>
                </div>

                <div className="flex  justify-center">
                  <OrangeButton className="!w-[189px]" label={'Submit'} />
                </div>
              </form>
            </div>
          </div>
        </Box>
      </div>

      <Footer />
    </div>
  );
};

export default Partnerships;
